<template>
  <div>
    <div class="d2-mr personal-wrap">
      <span class="log" @click="clickHandler" :class="{ 'new': v.isNew }">更新日志</span>
      <i class="el-icon-s-tools" style="marginRight:20px;cursor:pointer" v-if="userInfo.beSuper" @click="setTitle" />
      <el-popover ref="popover1" placement="top-start" width="400" @show="redPotShow = false" popper-class="popper"
                  v-model="visible" trigger="hover">
        <p class="title">
          导出和导入任务
        </p>
        <p class="tips">
          导出和导入任务加载完成后将自动进行下载，加载过程中不要离开系统,否则将导致任务自动清空
        </p>
        <div v-for="(item, index) in dowloadList" :key="index" class="downloadSty">
          <span class="one-line-ellipsis downName">{{ item.name }}</span>
          <span class="downLabel"> {{ item.labelText ? item.labelText : '导出中' }}</span>
        </div>
        <div v-for="(item, index) in updateList" :key="index + 'a'" class="updateListClass">
          <div v-if="item.progress != 100">
            <p>{{ item.name }}</p>
            <el-progress :percentage="item.progress ? item.progress : 2" />
          </div>
          <div v-else>
            <p>{{ item.name || '' }}</p>
            <p>成功{{ item.succNum }}条<span v-if="item.failNum">，失败{{ item.failNum }}条</span></p>
          </div>
        </div>
        <!-- @click="test" -->
        <span slot="reference">
          <i class="el-icon-bell tipsIcon " :class="{ 'redPot': redPotShow }" />
        </span>
      </el-popover>

      <span v-if="show" class="btn-text">{{ info && info.detail ? (info.detail.userType == 2 ? `${info.detail.userName}` :
        '管理员') : '未登录' }}</span>
      <span class="btn-text out-txt" @click="clear">退出</span>

    </div>
    <!-- 隐私协议 -->
    <privacy-agreement-dialog :privacy-visible="privacyVisible" v-if="privacyVisible" @dialogClose="privacyClose" />
  </div>
</template>

<script>
// mapMutations
import { mapActions, mapState, mapMutations } from 'vuex'
import { Version } from 'glsx-common-sdk'
// import PersonalPanel from '../personal-panel'
import { getImportResult } from '@api/order'
import { exportExcel, asyncExportExcel } from '@api/sys.base'
import { downLoadFile } from '@/common/util'
import privacyAgreementDialog from './privacyAgreementDialog'
var dowloadTimer = 0
var uploadTimer = 0
const version = new Version({
  request: {
    baseUrl: 'https://config-center-backend.glsx.com.cn/glsxAdmin/config',
    isSign: false
  }
})
export default {
  components: {
    privacyAgreementDialog
  },
  data() {
    return {
      userInfo: this.$store.state.d2admin.user.info,
      show: true,
      accountPanelVisible: false,
      userVisible: false,
      visiblepop: true,
      visible: false,
      accountInfo: {
        accountList: []
      },
      info: {},
      // statusLabel:{
      //   'waiting':'导出中',
      //   'polling':'导出中',

      // },
      timeStep: [0, 1, 3, 5, 8, 15],
      // timeStep: [0, 1],
      dowloadTimerNum: 0,
      // dowloadTimer: 0,
      uploadTimerNum: 0,
      redPotShow: false,
      isWorking: false,
      privacyVisible: false,
      v: {}
    }
  },
  computed: {
    ...mapState({
      dowloadList: (state) => state.d2admin.user.dowloadList,
      updateList: (state) => state.d2admin.user.updateList,
      waitDownloadList: (state) => {
        return state.d2admin.user.dowloadList.filter((item) => {
          return item.status == 'waiting'
        })
      },
      pollDownloadList: (state) => {
        return state.d2admin.user.dowloadList.filter((item) => {
          return item.status == 'polling'
        })
      },
      endDownloadList: (state) => {
        return state.d2admin.user.dowloadList.filter((item) => {
          return item.status == 'end'
        })
      }
    })
  },
  watch: {
    dowloadList: {
      handler(val, oldVal) {
        // console.log('watch', val)
        // const searchList = val.filter(item => !item.ifSuccess)
        // const searchList = val.filter(item => !item.ifSuccess)
        // console.log(this.dowloadList)
        // || this.pollDownloadList.length
        const oldList = oldVal || []
        if (val.length > oldList.length) {
          this.redPotShow = true
          const that = this
          setTimeout(() => {
            that.visible = true
          }, 2000)
        }

        if (this.waitDownloadList.length) {
          this.getDownloaduuid()
          // console.log('searchList.length', searchList.length)
          // const oldList = oldVal || []
          // console.log(!oldList || val.length > oldList.length)
          // if (!this.isWorking) {

          // }

          // if (!oldList || val.length > oldList.length) {
          //   this.redPotShow = true
          //   const that = this
          //   setTimeout(() => {
          //     that.visible = true
          //   }, 2000)
          //   clearInterval(dowloadTimer)
          //   this.dowloadTimerNum = 0
          //   // this.getUploadlistInfo(searchList)
          //   this.getDownloadslistInfo(searchList)
          // }
        }
        if (this.pollDownloadList.length && !this.isWorking) this.getDownloadslistInfo()
      },
      deep: true,
      immediate: true
    },

    updateList: {
      handler(val, oldVal) {
        // console.log('watch', val)
        // console.log('oldVal', oldVal)
        // 假如相等可以认为是轮询结果,跳过
        // 只有新老长度有变化才可以认为是新增的
        const searchList = val.filter(item => !item.ifSuccess)
        if (searchList.length) {
          // console.log('searchList.length', searchList.length)
          const oldList = oldVal || []
          // console.log(!oldList || val.length > oldList.length)
          if (!oldList || val.length > oldList.length) {
            this.redPotShow = true
            const that = this
            setTimeout(() => {
              that.visible = true
            }, 2000)
            clearInterval(uploadTimer)
            this.uploadTimerNum = 0
            this.getUploadlistInfo(searchList)
          }
        }
      },
      deep: true,
      immediate: true
    }

    // 调用其他接口，导致表格刷新-标识
    // '$store.state.d2admin.refreshtable.value'(val) {
    //   (val === 'fresh') && this.refreshEmit()
    // }
  },
  mounted() {
    this.show = false
    this.$event.$on('e-password-dialog', res => (this.passVisible = res))
    this.getInfo()
    this.getUpdateLogCofig()
  },
  methods: {
    ...mapActions('d2admin/user', ['load', 'loadAcocunt', 'actionSetDownloadList']),
    ...mapActions('d2admin/account', ['logout']),
    ...mapMutations('d2admin/user', ['setUpdateRefesh']),
    getUploadlistInfo(list) {
      // if (this.dowloadTimer) {
      const that = this
      const num = this.timeStep[this.uploadTimerNum] ?? 15
      // console.log(num)
      // console.log('num', num)
      // console.log(dowloadTimer)
      uploadTimer = setTimeout(() => {
        that.getUpload(list)
      }, num * 1000)
      // }
      this.uploadTimerNum++
    },
    getDownloaduuid() {
      // 后端导出对账单和合并导出都是只能同时一个, 解决内存问题
      const methodLists = ['dj.api.smartcarlife.goodsOrderProfitAllocation.export.async',
        'dj.api.smartcarlife.goodsOrderProfitAllocation.exportAccountStatement.async'
      ]
      const isOnlyReq = this.pollDownloadList.some((item) => {
        const { method } = JSON.parse(item.exportParam)
        return methodLists.includes(method)
      })
      console.log(isOnlyReq)
      if (this.pollDownloadList.length >= 3 || isOnlyReq) return

      const params = Object.assign(this.waitDownloadList[0])
      // async const result = await
      params && asyncExportExcel({ exportParam: params.exportParam }).then((result) => {
        if (result) {
          this.dowloadTimerNum = 0
          const list = this.dowloadList.map((item) => {
            if (item.timeid == params.timeid) {
              item.status = 'polling'
              item.uuid = result
            }
            return item
          })
          this.actionSetDownloadList({ list, type: 'dowloadList' })
          !this.isWorking && this.getDownloadslistInfo()
        }
      }).catch((err) => {
        console.log(err)
      })

      // console.log(result)
    },
    getDownloadslistInfo() {
      // if (this.dowloadTimer) {
      this.isWorking = true
      const that = this
      const num = this.timeStep[this.dowloadTimerNum] ?? 15
      // console.log(num)
      // console.log('num', num)
      // console.log(dowloadTimer)
      uploadTimer = setTimeout(() => {
        that.getDownloads()
      }, num * 1000)
      // }
      this.dowloadTimerNum++
    },
    getUpload(list) {
      // 模拟接口调用
      const fileUuidList = list.map((item) => {
        return item.uuid
      })
      // console.log(uuids)
      // return
      getImportResult({ fileUuidList }).then((result) => {
        let flag = false
        // 根据情况处理数据
        const list = this.updateList.map((item, index) => {
          result.forEach((ele) => {
            if (ele.uuid == item.uuid) {
              item = Object.assign(item, ele)
              // 新增逻辑 可能progress完成 但这两个数据还没写入 failNum succNum
              item.ifSuccess = ele.progress == 100 && (ele.failNum > 0 || ele.succNum > 0)
              if (item.ifSuccess) {
                flag = true
                if (ele.failNum && ele.succNum != 0) {
                  this.notice.warningTips('部分导入失败,请修改后重新导入')
                  setTimeout(() => {
                    downLoadFile(ele.url)
                  }, 7000)
                } else if (ele.failNum && ele.succNum == 0) {
                  this.notice.warningTips('导入失败,请修改后重新导入')
                  setTimeout(() => {
                    downLoadFile(ele.url)
                  }, 7000)
                } else {
                  this.notice.okTips('导入成功')
                }
              }
            }
          })
          return item
        })
        // 判断是否需要刷新列表
        console.log('flag', flag)
        flag && this.setUpdateRefesh(true)
        this.actionSetDownloadList({ list, type: 'updateList' })
        // console.log(list)
        const needSearchList = this.filterNoSucces(list)
        console.log(needSearchList)
        // return
        if (needSearchList.length) {
          // this.uploadTimerNum++
          this.getUploadlistInfo(needSearchList)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getDownloads() {
      const fileUuidList = this.pollDownloadList.map((item) => {
        return item.uuid
      })
      // console.log('272', fileUuidList)
      // console.log('272', this.waitDownloadList)
      // return
      fileUuidList.length && exportExcel({ fileUuidList }).then((result) => {
        console.log(result)
        // return
        // const flag = false
        const status = {
          0: '导出中',
          1: '导出成功',
          2: '导出失败'
        }
        // 根据情况处理数据
        // console.log(this.dowloadList)
        let needAdd = false
        const list = this.dowloadList.map((item) => {
          // item.labelText = '导出中'
          console.log(item)
          result.forEach((ele, index) => {
            if (ele.fileUuid == item.uuid) {
              // item = Object.assign(ele, item)
              item.ifSuccess = ele.status != 0
              if (ele.status != 0) item.status = 'end'
              if (ele.status == 1) {
                needAdd = true
                setTimeout(() => {
                  downLoadFile(ele.fileUrl)
                }, index * 7000)
                this.notice.okTips(status[ele.status])
              } else if (ele.status == 2) {
                needAdd = true
                this.notice.warningTips(status[ele.status])
              }
              item.labelText = status[ele.status]
            }
          })
          // console.log(item)
          return item
        })
        if (this.waitDownloadList.length && needAdd) this.getDownloadslistInfo()
        this.actionSetDownloadList({ list, type: 'dowloadList' })
        // const needSearchList = this.filterNoSucces(list)
        // console.log(needSearchList)
        // return
        this.$nextTick(() => {
          if (this.pollDownloadList.length) {
            this.dowloadTimerNum++
            this.getDownloadslistInfo()
          } else {
            this.isWorking = false
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    filterNoSucces(list) {
      // console.log(list)
      return list.filter((item) => {
        return !item.ifSuccess
      })
    },
    // test() {
    //   console.log('click')
    //   // const list = [
    //   //   // {
    //   //   //   name: 'xxx店订单补录2022-02-04test',
    //   //   //   ifSuccess: false,
    //   //   //   id: 1,
    //   //   //   status: 'loading',
    //   //   //   type: 'upload',
    //   //   //   labelText: '导入成功110条, 导入失败1条'
    //   //   // }
    //   // ]
    //   const list = [{
    //     uuid: '5b2a53b5-6aeb-49ba-9691-8c32903327e8',
    //     name: 'test2',
    //     ifSuccess: false,
    //     labelText: ''
    //   }]

    //   this.actionSetDownloadList({ list, type: 'updateList' })
    // },
    handleChangeAccount() {
      this.accountPanelVisible = !this.accountPanelVisible
    },
    handleAccountClose() {
      this.userVisible = !this.userVisible
      this.accountPanelVisible = false
    },
    async getUpdateLogCofig() {
      // const loginpath = this.auth?.session?.loginpath
      // if (loginpath) {
      // const product = loginpath === '/login' ? 'md' : loginpath.slice(1)
      this.v = await version.get({ moduleUrl: `dj-carlife-web`, env: 'update' })
      // }
    },
    clickHandler() {
      this.v = version.set()
      this.v.link && window.open(this.v.link)
    },
    /**
     * @description 登出
     */
    clear() {
      this.$confirm('确认退出？', '退出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const reload = async () => {
          localStorage.clear()
          await this.logout()
          window.location.reload()
        }
        reload()
        // if (this.$router.currentRoute.name === 'index') {
        //   reload()
        // } else {
        //   // this.$router.push({ name: 'index' })
        //   this.$router.push({ name: 'login' })
        //   var _t = setInterval(() => {
        //     if (this.$router.currentRoute.name === 'index') {
        //       clearInterval(_t)
        //       reload()
        //     }
        //   }, 0)
        // }
      }).catch(() => { })
    },
    async logOut() {
      this.$confirm('确认退出？', '退出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$router.push('/login')
        await this.logout()
        await this.$StoreReset.call(this.$store) // 重置 store
      }).catch(() => { })
    },
    async getInfo() {
      this.info = await this.load()
      this.accountInfo = await this.loadAcocunt()
      this.$nextTick(() => {
        this.show = true
      })
    },

    setTitle() {
      this.privacyVisible = !this.privacyVisible
      console.log(this.privacyVisible)
    },

    privacyClose() {
      this.privacyVisible = !this.privacyVisible
    }
  },
  beforeDestroy() {
    clearInterval(dowloadTimer)
    clearInterval(uploadTimer)
  }
}
</script>
<style lang="scss">
.personal-wrap {
  transform: translateY(-3px);
}

.personal-wrap .arrow-icon {
  cursor: pointer;
}

.el-icon-arrow-down {
  transition: all 0.2s ease-in-out;
}

.personal-wrap .arrow-icon.drOpen {
  transform: rotate(-180deg);
}

.tipsIcon {
  font-size: 12px;
  position: relative;
}

.log {
  position: relative;
  margin-right: 30px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
}

.log.new::after {
  content: "New";
  font-size: 10px;
  color: #fff;
  padding: 0px 1px;
  border-radius: 2px;
  // width: 6px;
  // height: 6px;
  border-radius: 3px 0 3px 0;
  background-color: red;
  position: absolute;
  top: -8px;
  right: -23px;
  transform: scale(0.9);
}

.redPot::after {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: red;
  position: absolute;
  top: -2px;
  right: -2px;
}

.popper {
  padding: 20px 18px 16px;
  z-index: 200;
  max-height: 95vh;
  overflow: auto !important;
  .title {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 16px;
    margin-top: 0;
    color: #333;
  }

  .downloadSty {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .downName {
    width: 70%;
    overflow: hidden;
  }

  .tips {
    word-break: break-all;
    font-size: 14px;
    color: #333;
  }

  .updateListClass {
    margin-bottom: 15px;

    p {
      margin: 5px 0;
    }
  }
}

.accout-panel {
  left: -160px;
  top: 0;
}

.accout-panel .panel-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 10em;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  font-size: 14px;
  color: #606266;
  user-select: none;
  cursor: pointer;
}

.accout-panel .i {
  margin-right: 5px;
}

.accout-panel .hidden {
  display: none;
}

.accout-panel .el-button--text {
  color: #606266;
}

.setC {
  margin-right: 20px;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
